import { requests } from '../../../api/agent'

export default {
    getList: (params) => requests.getWithParams('/ReTypeApplicantNotifications/GetTypeApplicantNotificationsList', params),
    getPaged: (params) => requests.getWithParams('/ReTypeApplicantNotifications/GetTypeApplicantNotificationsPaged', params),
    create: (params) => requests.post('/ReTypeApplicantNotifications/CreateTypeApplicantNotification', params),
    delete: (params) => requests.post('/ReTypeApplicantNotifications/DeleteTypeApplicantNotification', params),
    update: (params) => requests.post('/ReTypeApplicantNotifications/UpdateTypeApplicantNotification', params)
}